<template>
  <portal to="ModalRecommendation">
    <div
      id="modalPassword"
      class="modal fade"
      role="dialog"
      aria-labelledby="modalPassword"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body">
            <div class="px-5 py-3">
              <small class="font-weight-bold">
                {{ $t('user-profile.password.label.new') }}
              </small>
              <div class="position-relative">
                <input
                  v-model.trim="$v.password.password.$model"
                  :type="types.password"
                  class="form-control pr-5"
                  :class="{ 'is-invalid': $v.password.password.$error }"
                >
                <a
                  class="password-reveal"
                  @click="revealPassword('password')"
                >
                  <i
                    class="fa fa-eye"
                    aria-hidden="true"
                  />
                </a>
              </div>
              <div
                v-if="!$v.password.password.required && $v.password.password.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.password.error.new") }}
                </small>
              </div>
              <div
                v-if="!$v.password.password.minLength"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.password.error.new-minlength") }}
                </small>
              </div>
              <br>
              <span class="d-flex justify-content-between">
                <small class="font-weight-bold">
                  {{ $t('user-profile.password.label.confirm') }}
                </small>
                <small
                  v-if="(password.password === password.passwordConfirm) && password.passwordConfirm"
                  class="text-success font-weight-bold"
                >
                  {{ $t('user-profile.password.not-error.confirm') }}
                  <img
                    src="@/assets/icon/checklist-green.png"
                    alt="check"
                  >
                </small>
                <small
                  v-if="(password.password !== password.passwordConfirm) && password.passwordConfirm"
                  class="text-danger font-weight-bold"
                >
                  {{ $t('user-profile.password.error.confirm') }}
                  <img
                    src="@/assets/icon/close.png"
                    alt="not-check"
                  >
                </small>
              </span>
              <div class="position-relative">
                <input
                  v-model="password.passwordConfirm"
                  :type="types.confirm"
                  class="form-control pr-5"
                >
                <a
                  class="password-reveal"
                  @click="revealPassword('confirm')"
                >
                  <i
                    class="fa fa-eye"
                    aria-hidden="true"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-outline-info col-6 col-md-4 py-2"
              data-dismiss="modal"
            >
              <small class="font-weight-bold">
                {{ $t('user-profile.password.button.close') }}
              </small>
            </button>
            <button
              type="button"
              class="btn btn-info col-6 col-md-4 py-2"
              @click="savePassword"
            >
              <small class="font-weight-bold">
                {{ $t('user-profile.password.button.save') }}
              </small>
            </button>
          </div>
        </div>
      </div>
      <ModalSuccess
        v-if="modal.success"
        :text-modal="modal.textModal"
        @closeModal="closeModal"
      />
    </div>
  </portal>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import ModalSuccess from '@/components/modal/ModalSuccess.vue'
import Api from '@/utils/Api'
import $ from 'jquery'

export default {
  name: 'ModalPassword',

  components: {
    ModalSuccess
  },

  props: {
    id: {
      type: String,
      default: () => ('')
    }
  },

  data () {
    return {
      types: {
        password: 'password',
        confirm: 'password'
      },
      password: {
        password: '',
        passwordConfirm: ''
      },
      modal: {
        textModal: '',
        success: false
      }
    }
  },

  methods: {
    async savePassword () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const data = await Api.users.putPassword(this.id, this.password)
        if (data.status === 200) {
          if (this.$i18n.locale === 'en') {
            this.modal.textModal = 'Success'
          }
          if (this.$i18n.locale === 'id') {
            this.modal.textModal = 'Sukses'
          }
          this.password.password = ''
          this.password.passwordConfirm = ''
          this.showModal('success')
        }
      }
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      $('#modalPassword').modal('hide')
      this.$v.$reset()
    },
    revealPassword (type) {
      this.types[type] = this.types[type] === 'password'
        ? 'text'
        : 'password'
    }
  },

  validations: {
    password: {
      password: {
        required,
        minLength: minLength(5)
      }
    }
  }
}
</script>
